import { render, staticRenderFns } from "./MyTabs.vue?vue&type=template&id=e2f4468a"
import script from "./MyTabs.vue?vue&type=script&lang=js"
export * from "./MyTabs.vue?vue&type=script&lang=js"
import style0 from "./MyTabs.vue?vue&type=style&index=0&id=e2f4468a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports